import { useState } from "react";
import ScheduleModal from "./ScheduleModal";
import { useQuery } from "@tanstack/react-query";
import { GetAllConsultants, ConsultantsDTO } from "../../api/Consultation/GetAllConsultants";
import Spinner from "../Shared/Spinner";
import PublicConsultantCard from "./PublicConsultantCard";
import { Swiper, SwiperSlide } from "swiper/react";
const OurConsultantsSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedConsultant, setSelectedConsultant] = useState<ConsultantsDTO | null>(null); // Correctly typing the state
    const { data: Consultants, isLoading } = useQuery({
        queryFn: GetAllConsultants,
        queryKey: ["consultants"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const consultants = Consultants?.data;
    const handleOpenModal = (consultant: ConsultantsDTO) => {
        setSelectedConsultant(consultant); // Store the selected consultant data
        setIsModalOpen(true); // Open the modal
    };

    return (
        <div className="pb-40 container">
            <div className="mb-16 space-y-3 text-center">
                <h1 className="font-semibold text-secondary sm:text-base text-sm">
                    We’re hiring!
                </h1>
                <h2 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-primary mx-auto">
                    Meet our mentors
                </h2>
                <p className="max-w-[764px] mx-auto sm:text-base text-sm">
                    Our philosophy is simple — hire a team of diverse, passionate people
                    and foster a culture that empowers you to do your best work.
                </p>
            </div>
            {isLoading ? (
                <div className="min-h-[40vh] h-full flex items-center justify-center">
                    <Spinner />
                </div>
            ) : (
                <>
                    <div className="sm:grid hidden lg:grid-cols-4 md:grid-cols-3 grid-cols-2 xl:gap-x-12 gap-x-6 gap-y-[52px] xl:px-8">
                        {consultants?.map((consultant) => (
                            <PublicConsultantCard
                                key={consultant.id}
                                consultant={consultant}
                                handleOpenModal={handleOpenModal}
                            />
                        ))}
                    </div>
                    <div className="sm:hidden block">
                    <Swiper
                        grabCursor={true}
                        navigation={{
                            nextEl: ".custom-next6",
                            prevEl: ".custom-prev6",
                        }}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={30}
                        autoplay={{
                            delay: 500,
                            disableOnInteraction: false,
                        }}
                        speed={3000}
                        className="mySwiper"
                        breakpoints={{
                            0: {
                                slidesPerView: 1.1,
                                spaceBetween: 10,
                            },
                            450: {
                                slidesPerView: 1.3,
                                spaceBetween: 10,
                            },
                            550: {
                                slidesPerView: 1.6,
                                spaceBetween: 10,

                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 12,

                            },
                            768: {
                                slidesPerView: 2.5,
                                spaceBetween: 20,

                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 25,

                            },
                        }}
                    >
                        {consultants?.map((consultant) => (
                            <SwiperSlide key={consultant.id} className="relative">
                                <PublicConsultantCard
                                    key={consultant.id}
                                    consultant={consultant}
                                    handleOpenModal={handleOpenModal}
                                />

                            </SwiperSlide>

                        ))}

                    </Swiper>

                    </div>
                </>
            )}

            {/* Modal is outside of the mapping loop */}
            <ScheduleModal
                isOpen={isModalOpen}
                closeModal={() => {
                    setIsModalOpen(false);
                }}
                consultant={selectedConsultant} // Pass the full consultant data
            />
        </div>
    );
};

export default OurConsultantsSection;
